import serviceApi from '@/utils/request'
import { getToken } from '@/utils/auth'
import qs from 'qs'
// 获取成员信息
export function getMemberInfo (memId) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member',
    method: 'get',
    headers:{
      Authentication: getToken()
    },
    params: { memId }
  })
}

// 生成分享海报
export function getInvitecode (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.invitecode',
    method: 'post',
    headers:{
      Authentication: getToken()
    },
    data: qs.stringify(data)
  })
}

//绑定微信
export function bangWechat (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.bangWechat',
    method: 'post',
    headers:{
      Authentication: getToken()
    },
    data: qs.stringify(data)
  })
}

// 修改成员信息
export function saveCustomer (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.saveCustomer',
    method: 'post',
    headers:{
      Authentication: getToken()
    },
    data: qs.stringify(data)
  })
}

// 修改成员信息
export function updateMember (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.updateMember',
    method: 'post',
    headers:{
      Authentication: getToken()
    },
    data: qs.stringify(data)
  })
}

// 安全更新信息
export function safeUpdate (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.safeUpdate',
    method: 'post',
    headers:{
      Authentication: getToken()
    },
    data: qs.stringify(data)
  })
}

export function Verify (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'Verify',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 上传图片
export function uploadFile  (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.updateMember',
    method: 'post',
    headers:{
      Authentication: getToken(),
      "Content-Type": "multipart/form-data"
    },
    data: qs.stringify(data)
  })
}

// 获取购物车
export function getShopCart (memId, carId) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.shopcart',
    method: 'get',
    headers:{
      Authentication: getToken()
    },
    params: { memId, carId }
  })
}

// 获取收获地址
export function selectAddress (memId) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.selectAddress',
    method: 'get',
    headers:{
      Authentication: getToken()
    },
    params: { memId }
  })
}

// 添加收获地址
export function addAddress (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.addAddress',
    method: 'post',
    headers:{
      Authentication: getToken()
    },
    data: qs.stringify(data)
  })
}

// 删除收获地址
export function delAddress (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.delAddress',
    method: 'post',
    headers:{
      Authentication: getToken()
    },
    data: qs.stringify(data)
  })
}

// 删除购物车
export function deleteShopCart (data) {
  return serviceApi.service({
    url: serviceApi.serviceApi + 'member.deleteShopCart',
    method: 'post',
    headers:{
      Authentication: getToken()
    },
    data: qs.stringify(data)
  })
}

// 获取部门列表信息
export function getDepartmentList (departId) {
  return serviceApi.service({
    url: '/WeixinWorkAPI/GetDepartmentList',
    method: 'get',
    params: { departId }
  })
}



// WEBPACK FOOTER //
// ./src/api/Member.js